<!--
  CustomerComplianceResultsFilter renders a filter with dropdown options for business compliance
  agent run results and reads/writes from the `compliance_results` URL query param.
-->

<script>
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';
import {
  COMPLIANCE_RESULT,
  COMPLIANCE_RESULT_TO_READABLE_LABEL,
} from '@/constants/businessComplianceAgent';

export default {
  components: {
    iFilter,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      options: Object.values(COMPLIANCE_RESULT_TO_READABLE_LABEL).map(
        (label) => ({ label }),
      ),
    };
  },
  computed: {
    value() {
      const compliance_results = this.params.compliance_results;
      if (!compliance_results) {
        return [];
      }
      let paramsAsArray = [];
      if (typeof compliance_results === 'string') {
        paramsAsArray = [compliance_results];
      } else {
        paramsAsArray = compliance_results;
      }
      // map query params like 'PASS' to dropdown values like 'Pass'
      return paramsAsArray.map(
        (param) => COMPLIANCE_RESULT_TO_READABLE_LABEL[param],
      );
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(updated) {
      // Convert readable labels back to API parameter values
      const mapEntries = Object.entries(COMPLIANCE_RESULT_TO_READABLE_LABEL);
      const updatedParamVals = updated.selection.map((item) => {
        const [param] = mapEntries.find(([_, label]) => label === item.label);
        return param;
      });
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          compliance_results:
            updatedParamVals.length > 0 ? updatedParamVals : undefined,
        },
      });
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.CUSTOMERS_SEARCH_CLICKED, {
        itemName: `filter_compliance_results`,
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Compliance"
    data-testid="compliance-result-filter"
    data-dd-action-name="customers-view-compliance-results-filter"
    :options="options"
    :model-value="value"
    :searchable="false"
    @selection-changed="onSelectionChanged"
  />
</template>
